import { render, staticRenderFns } from "./kyc-asset-withdraw-address-certification-list.vue?vue&type=template&id=e3ab8e96&"
import script from "./kyc-asset-withdraw-address-certification-list.vue?vue&type=script&lang=js&"
export * from "./kyc-asset-withdraw-address-certification-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports